// Content for the "How we Transform" page (static, from the uploaded design)

export const TRUST_ITEMS = [
  {
    image: "/images/transform/trust-business-led.png",
    title: "Business-led",
    sub: "Real business outcomes",
  },
  {
    image: "/images/transform/trust-structured.png",
    title: "Structured approach",
    sub: "Proven methodology",
  },
  {
    image: "/images/transform/trust-expert-teams.png",
    title: "Expert teams",
    sub: "End-to-end capability",
  },
  {
    image: "/images/transform/trust-flexible.png",
    title: "Flexible engagement",
    sub: "From advisory to full delivery",
  },
  {
    image: "/images/transform/trust-lasting-impact.png",
    title: "Lasting impact",
    sub: "Built to evolve",
  },
];

export const JOURNEY_STEPS = [
  { n: "01", title: "Discover Your AI Opportunities", sub: "Explore what’s possible for your business." },
  { n: "02", title: "AI Transformation Audit", sub: "Deep dive assessment of your business, data and readiness." },
  { n: "03", title: "AI Transformation Blueprint", sub: "Prioritized roadmap with clear outcomes and plan." },
  { n: "04", title: "Validate / PoC", sub: "Test, learn and de-risk before scaling." },
  { n: "05", title: "Build & Deploy", sub: "Develop and integrate AI solutions into your business." },
  { n: "06", title: "Measure Outcomes", sub: "Track value, refine and scale." },
  { n: "07", title: "Continuous Transformation", sub: "Keep discovering and creating new value." },
];

export const DIFFERENCE_CARDS = [
  { icon: "Building2", color: "#8367E8", title: "Business Understanding", sub: "We start with your goals, processes and operating reality." },
  { icon: "BrainCircuit", color: "#5BCC8A", title: "AI Depth", sub: "From models to agents, enterprise knowledge systems and private AI." },
  { icon: "Rocket", color: "#F08B49", title: "Execution Strength", sub: "150+ engineers. Enterprise-grade delivery. Built for scale." },
  { icon: "Infinity", color: "#779EEA", title: "Built to Evolve", sub: "A long-term partner for your AI journey." },
];

export const CASE_STUDIES = [
  {
    img: "case-professional",
    tag: "Professional Services",
    title: "From manual to intelligent resource planning",
    stats: [
      { value: "40%", label: "Faster planning" },
      { value: "3x", label: "More accuracy" },
    ],
  },
  {
    img: "case-healthcare",
    tag: "Healthcare",
    title: "AI-powered knowledge access for care teams",
    stats: [
      { value: "50%", label: "Less search time" },
      { value: "30%", label: "Better outcomes" },
    ],
  },
  {
    img: "case-manufacturing",
    tag: "Manufacturing",
    title: "Predictive insights for operational efficiency",
    stats: [
      { value: "25%", label: "Less downtime" },
      { value: "20%", label: "Cost saved" },
    ],
  },
];
